<template>
	<Modals
		:title="'DevOps Ticket'"
		:display="display"
		:parentTag="'form'"
		:novalidate="'novalidate'"
		@show="close"
	>
		<template #modal-content>
			<div class="error-log__resolved-azure-devops-ticket">
				{{ isEditMode ? 'Edit or delete' : 'Add' }} the Azure DevOps bug
				ticket number.
			</div>
			<div class="error-log__ticket-container">
				<Input
					v-model="azureDevOpsTicket"
					:inputType="'numeric'"
					:placeholder="'ex.123456'"
					:helpText="helpTextDevOpsTicket"
					:width="124"
					:forceCustomErrorMessage="errorLogCustomErrorMessage"
					@blur="setAzureDevOpsTicket"
					data-test="azureDevOpsTicketText"
				/>
				<Button
					v-if="isEditMode"
					className="btn--icon-only"
					iconClassName="icon-delete-glenn"
					:iconBeforeLabel="true"
					:btnClick="clearAzureDevOpsTicket"
				/>
			</div>
		</template>
		<template #modal-footer>
			<ButtonGroup
				:items="[
					{
						id: 'saveButtonModal',
						className: 'btn--primary',
						labelText: 'Save',
						type: 'submit',
						btnClick: saveAzureTicket,
						disabled: hasError || hasSameAzureTicket
					},
					{
						id: 'cancelButtonModal',
						labelText: 'Cancel',
						btnClick: close
					}
				]"
			/>
		</template>
	</Modals>
</template>
<script>
import Modals from '@/components/shells/modal/modals';
import ButtonGroup from '@/components/forms/button/button-group';
import Input from '@/components/forms/input/input.vue';
import Button from '@/components/forms/button/button';
import { requiredIf, minLength, maxLength } from 'vuelidate/lib/validators';

export default {
	name: 'ErrorDevOpsTicketModal',
	components: {
		Modals,
		ButtonGroup,
		Input,
		Button
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		resolvedAzureDevOpsUrl: {
			type: String,
			default: ''
		},
		action: {
			type: String,
			required: true
		}
	},
	validations: {
		azureDevOpsTicket: {
			required: requiredIf(function() {
				return this.action === 'add';
			}),
			numeric: function(value) {
				return (
					(this.action === 'edit' && value === '') ||
					/^[0-9]+$/.test(value)
				);
			},
			minLength: minLength(5),
			maxLength: maxLength(7)
		}
	},
	data() {
		return {
			azureDevOpsTicket: ''
		};
	},
	computed: {
		isEditMode() {
			return this.action === 'edit';
		},
		hasSameAzureTicket() {
			return (
				this.azureDevOpsTicket?.toString().trim() ===
				this.resolvedAzureDevOpsUrl?.trim()
			);
		},
		errorLogCustomErrorMessage() {
			if (this.$v.azureDevOpsTicket.$dirty) {
				if (
					!this.$v.azureDevOpsTicket.required ||
					!this.$v.azureDevOpsTicket.numeric ||
					!this.$v.azureDevOpsTicket.minLength ||
					!this.$v.azureDevOpsTicket.maxLength
				) {
					return 'Enter 5 - 7 numbers';
				} else {
					return '';
				}
			} else {
				return '';
			}
		},
		hasError() {
			return !!this.errorLogCustomErrorMessage;
		},
		helpTextDevOpsTicket() {
			if (this.errorLogCustomErrorMessage) {
				return '';
			}
			return 'Enter 5 - 7 numbers';
		}
	},
	methods: {
		close() {
			this.azureDevOpsTicket = '';
			this.$v.azureDevOpsTicket.$reset();
			this.$emit('show', false);
		},
		setAzureDevOpsTicket() {
			this.$v.azureDevOpsTicket.$touch();
		},
		saveAzureTicket(e) {
			if (e) e.preventDefault();
			this.$emit('save', this.azureDevOpsTicket);
			this.close();
		},
		clearAzureDevOpsTicket() {
			this.azureDevOpsTicket = '';
		}
	},
	watch: {
		display: {
			deep: true,
			handler(val) {
				if (val && this.resolvedAzureDevOpsUrl) {
					this.azureDevOpsTicket = this.resolvedAzureDevOpsUrl;
				}
			}
		}
	}
};
</script>
<style lang="scss" scoped>
::v-deep .modal {
	@include mq($from: md) {
		width: 374px;
	}
}
::v-deep .modal {
	&__body {
		overflow: initial;
	}
}
.error-log {
	@include mq($from: md) {
		width: 85vw;
	}

	@include mq($from: md-l) {
		width: 75vw;
		max-width: 840px;
	}
	&__resolved-azure-devops-ticket {
		@include body-text('sm');
		margin-bottom: $gutter-lg;
	}
	&__ticket-container {
		display: flex;
		align-items: flex-start;
		gap: $gutter-md;
	}
}
</style>
